define([
	"dojo/_base/declare",
	"dojo/_base/event",
	"dojo/dom-class",
	"dojo/keys",
	"dojo/sniff",
	"dijit/form/Textarea",
	"csi/html",
	"csi/widget/_InsertNewlineMixin"
], function(declare, event, domClass, keys, sniff, Textarea, html, _InsertNewlineMixin) {

	return declare([Textarea,_InsertNewlineMixin], {
		// Boolean; indicates if textarea should expand upwards rather than downwards (i.e. anchored to the bottom rather than the top)
		bExpandUp: false,

		postCreate: function() {
			// summary: connect to onkeydown event
			this.inherited(arguments);

			domClass.add(this.domNode, "dijitReset");

			// on Firefox, need to see if we can shrink to one row rather than default of 2; Dojo seems to indicate
			// this is an issue with Firefox and allocating space for scrollbars, to fix this use overflow hidden
			if (sniff("ff")) {
				$(this.focusNode).css({overflow: "hidden"});
			}
		},

		resize: function() {
			// summary: if so configured, adjust top position after resize to expand the text box up rather than down
			var focusObj = $(this.focusNode.offsetParent);
			var heightBefore = focusObj.height();

			this.inherited(arguments);

			if (heightBefore && this.bExpandUp) {
				var heightDelta = focusObj.height() - heightBefore;
				if (heightDelta) {
					var topPos = parseInt(focusObj.css('top'), 10) - heightDelta;
					focusObj.css({top: topPos + "px"});
				}
			}
		},
	});
});